import axios from 'axios';

// Ensure we have a valid API URL
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: 'application/json',
  },
});

// Add request interceptor for logging
api.interceptors.request.use((request) => {
  console.log('API Request:', {
    url: request.url,
    baseURL: request.baseURL,
    method: request.method,
  });
  return request;
});

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', {
      message: error.message,
      config: error.config,
      response: error.response?.data,
    });
    throw error;
  }
);

// Helper function to get authenticated API instance
export const getAuthenticatedApi = () => {
  const token = localStorage.getItem('token');

  if (token) {
    return {
      ...api,
      defaults: {
        ...api.defaults,
        headers: {
          ...api.defaults.headers,
          Authorization: `Bearer ${token}`,
        },
      },
    };
  }

  return api;
};

// Helper function to add auth header to a request
export const withAuth = (config = {}) => {
  const token = localStorage.getItem('token');

  if (!token) {
    return config;
  }

  return {
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${token}`,
    },
  };
};

export default api;
